module.exports = __webpack_public_path__ + "img/76.62b88f75.jpg";